<template>
  <FormLayout title="Cập nhật tài khoản kế toán">
    <template v-slot:form>
      <InstallmentForm
        :form-data="formData"
        :errors="errors"
      />
    </template>
    <template v-slot:actions>
      <FormActions
        :loading="submitting"
        @save="updateInstallment(formData)"
        @cancel="handleCancel"
        :cancel-route="{
          name: 'list-installment',
        }"
      />
    </template>
  </FormLayout>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import FormActions from '../shared/components/FormActions.vue';
import FormLayout from '../shared/components/FormLayout.vue';
import InstallmentForm from '../shared/components/InstallmentForm.vue';
import installmentFormMixin from '../shared/mixins/installmentFormMixin';

export default {
  name: 'InstallmentCategoryUpdate',
  components: {
    InstallmentForm,
    FormActions,
    FormLayout,
  },
  mixins: [installmentFormMixin],
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Dịch vụ trả góp', route: '/installments' },
      { title: 'Cập nhật dịch vụ trả góp', route: '/update-installment' },
    ]);
    this.fetchCategory();
  },
  methods: {
    async fetchCategory() {
      try {
        const id = this.$route.query.id || this.$route.params.id;
        if (!id) {
          this.makeToastFaile &&
            this.makeToastFaile('Không tìm thấy ID tài khoản');
          return;
        }

        const response = await this.$store.dispatch(
          'installmentCategory/getCategoryById',
          id,
        );
        this.setFormData(response.data);
      } catch (error) {
        this.handleError && this.handleError(error);
      }
    },
    async updateInstallment(formData) {
      if (!this.validateForm(formData)) return;

      this.submitting = true;
      try {
        const id = this.$route.query.id || this.$route.params.id;
        if (!id) {
          this.makeToastFaile &&
            this.makeToastFaile('Không tìm thấy ID tài khoản');
          return;
        }

        await this.$store.dispatch('installmentCategory/updateCategory', {
          id,
          ...formData,
        });
        this.makeToastSuccess &&
          this.makeToastSuccess('Cập nhật tài khoản thành công');
        this.$router.push({
          name: 'list-installment',
        });
      } catch (error) {
        this.handleError && this.handleError(error);
      } finally {
        this.submitting = false;
      }
    },
    handleCancel() {
      this.$router.push({
        name: 'list-installment',
      });
    },
  },
};
</script>
